import { render, staticRenderFns } from "./machineNotify.vue?vue&type=template&id=3fbc4e94&scoped=true&"
import script from "./machineNotify.vue?vue&type=script&lang=js&"
export * from "./machineNotify.vue?vue&type=script&lang=js&"
import style0 from "./machineNotify.vue?vue&type=style&index=0&id=3fbc4e94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc4e94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fbc4e94')) {
      api.createRecord('3fbc4e94', component.options)
    } else {
      api.reload('3fbc4e94', component.options)
    }
    module.hot.accept("./machineNotify.vue?vue&type=template&id=3fbc4e94&scoped=true&", function () {
      api.rerender('3fbc4e94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/message/machineNotify.vue"
export default component.exports